<template>
    <div v-if="offer" class="mb-5">
        <strong class="d-block">{{ offer.serviceName }}</strong>
        <strong class="d-block">{{ $t('date') }}: {{ $filters.dateFormat(offer.startDate) }}</strong>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, HIDE_CONDITIONAL_MODAL_INFO, SHOW_CRUISE_CONDITIONS_INFO} from '@/utils/event-bus'

    @Component
    export class CruiseConditionsModalInfo extends Vue {
        offer = {info: {}}

        mounted() {
            EventBus.$on(SHOW_CRUISE_CONDITIONS_INFO, this.showInfo)
            EventBus.$on(HIDE_CONDITIONAL_MODAL_INFO, this.hideInfo)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_CRUISE_CONDITIONS_INFO, this.showInfo)
            EventBus.$off(HIDE_CONDITIONAL_MODAL_INFO, this.hideInfo)
        }

        showInfo(offer) {
            this.offer = offer
        }

        hideInfo() {
            this.offer = null
        }
    }

    export default CruiseConditionsModalInfo
</script>
